import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  padding: 16px;
  width: 100%;
`;

export const Title = styled.h2`
  font-size: 16px;
  margin-bottom: 16px;
  font-family: inherit;
  font-weight: 500;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
  flex-direction: column;
  color: ${theme.colors.secondary800};
`;

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
`;

export const ItemText = styled.span<{ $isNode: boolean }>`
  line-height: 1.5;
  align-self: baseline;
  font-size: 16px;
  font-weight: ${({ $isNode }) => ($isNode ? 500 : 400)};
`;

export const SubList = styled.ul`
  list-style: none;
  padding: 0;
  margin-left: 16px;
`;

export const SubListItem = styled.li`
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 16px;

  &:before {
    content: '•';
    color: ${theme.colors.secondary800}
    font-size: 24px;
    display: inline-block;
    width: 8px;
    margin-right: 8px;
  }
`;
